import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { ACRouterLink } from 'academy-common-lib/components/ACRouterLink';
import { getListingUrl } from 'academy-common-lib/features/learningContentCard/routing/RoutingUtils';
import { getPlaylistUrl } from 'academy-common-lib/features/playlist/playlistRouting';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getContentTypeI18nKey = contentType => {
  if (contentType === 'LEARNING_PATH') {
    return 'academyCommon.contentTypes.HUBSPOT_PLAYLIST';
  }
  return `academyCommon.contentTypes.${contentType}`;
};
const getContentTo = (contentType, contentId) => {
  switch (contentType) {
    case 'LESSON':
    case 'TRACK':
    case 'COURSE':
    case 'SHORT_FORM_CONTENT':
      {
        const listingType = contentType === 'COURSE' ? 'TRACK' : contentType;
        return getListingUrl({
          type: listingType,
          id: contentId,
          isStarted: true
        });
      }
    case 'PLAYLIST':
    case 'LEARNING_PATH':
      return getPlaylistUrl(contentId);
    default:
      return null;
  }
};
const ContentTypeLabel = ({
  contentId,
  contentName,
  contentType
}) => {
  const contentTo = getContentTo(contentType, contentId);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [contentTo ? /*#__PURE__*/_jsx(ACRouterLink, {
      to: contentTo.fullUrl,
      children: contentName
    }) : contentName, /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getContentTypeI18nKey(contentType)
        })
      })
    })]
  });
};
export default ContentTypeLabel;